<template>
  <div id="app">
    <div class="wrapper">
      <div class="img__content">
        <img v-for="index in 4" :src="sources.base + '/' + index +'.png?t='+ Math.random()" :data-src="sources.base + '/' + index +'.png' " alt="">
      </div>
      <div class="img__footer"
            :class="{ 'img__footer--err' : err}">

        <button class="img__footer--btn" v-if="isApp" @click="openPage"></button>

        <a v-if="!isApp" class="img__footer--link" :href="linkedmeUrl"></a>
      </div>
    </div>
  </div>
</template>

<script>
  import PageMixin from "@/packages/mixins/Page.mixin"
  //import LazyLoad from "vanilla-lazyload"
  //import BScroll from 'better-scroll'
  import { isApp as checkisApp} from  "@/packages/utils"
  import infoConf from "@/configs/info.conf"
  const VERSION = '6.3.1'

  const MATCH_VERSION = () => checkisApp() ? (JSBinder.getVersion() === VERSION) : null
  export default {
    mixins: [
      PageMixin(),
    ],
    data(){
      return {
        version: '',
        isApp: false,
        MATCH_VERSION,
        linkedmeUrl: "https://lkme.cc/iHD/cQkxb9OBM",
        imgs_selector    : '.wrapper img',
        err: false,
        sources:{
          default: 'http://images.infzm.com/images/589804264981569746.jpg',
          base: 'http://images.infzm.com/images/20190221'
        }
      }
    },

    mounted () {
      setTimeout(async ()=> {

        this.isApp = checkisApp();

        try {

          this.version = (JSBinder.getVersion())
          JSBinder.activityDetails(infoConf.shareInfo.title,
            infoConf.shareInfo.desc,
            infoConf.shareInfo.imgUrl,
            infoConf.shareInfo.link)
        } catch (e) {

        }

        if(!checkisApp()) {
          this.linkedmeUrl = await this.$$getLinkmeUrl({
            version: '1.4.0',
            link_type: '8'
          })
        }
      },500)
    },

    methods: {
      async openPage() {
        if(!(checkisApp() ? (JSBinder.getVersion() === VERSION) : false))
        {
          //this.versionProp();
          return false
        } else {
          try {
            JSBinder.openPage('8', 'page://?native=infzm&link_type=8')
          }catch (e) {}
        }

      },
      versionProp() {
        this.err = true;
        setTimeout(()=> {
          this.err = !this.err;
        }, 5000)
      }

    }

  }

</script>

<style lang="scss">
  .wrapper {
    position: relative;
    .img {
      &__content {
        line-height: 0;
        font-size: 0;
      }
      &__footer {
        &--err {
          background-image: url("http://images.infzm.com/images/20190131/err1.png");
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: 0 66%;
        }

        position: absolute;
        bottom: 20px;
        height: 100px;
        width: 100%;
        display: flex;
        justify-content: start;
        align-items: flex-start;
        background-position: 0 100%;
        transition: background-position 1s;

        @media (min-height: 1024px) {
          height: 200px;
        }
        @media (min-height: 1366px) {
          height: 260px;
        }

        &--btn {
          height: 100px;
          width: 100%;
          opacity: 0;

        }
        &--link {
          height: 100px;
          width: 100%;
        }
      }
    }
  }

</style>


